import { useCallback, useEffect, useState } from 'react'
import { deleteAssistantReport, listAssistantReports } from '../api/assistant'

export function useAssistantReports() {
  const [reports, setReports] = useState([])
  const [retentionDays, setRetentionDays] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const reload = useCallback(async () => {
    setLoading(true)
    try {
      const { items, retentionDays: days } = await listAssistantReports()
      setReports(items)
      setRetentionDays(days)
      setError('')
    } catch (err) {
      setError(err.message || 'error')
    } finally {
      setLoading(false)
    }
  }, [])

  const remove = useCallback(async (id) => {
    await deleteAssistantReport(id)
    setReports((prev) => prev.filter((report) => report.id !== id))
  }, [])

  useEffect(() => {
    reload()
  }, [reload])

  return { reports, retentionDays, loading, error, reload, remove }
}

export default useAssistantReports
